"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnableIntegrationAlert = void 0;
var OAuthWindow_1 = __importDefault(require("@CommonFrontend/OAuth/OAuthWindow"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var react_1 = __importDefault(require("react"));
var styles = __importStar(require("./CreateOrEditAutomationModal.css"));
var EnableIntegrationAlert = function (_a) {
    var selectedTarget = _a.selectedTarget, apiBaseUrl = _a.apiBaseUrl, integrationChangeHandler = _a.integrationChangeHandler;
    var integrationUrlMapping = {
        slack: "/platform-integrations/slack/enable",
        hubspot: "/auth/hubspot?state=integration",
    };
    return (react_1.default.createElement("div", { className: styles.integrationAlert },
        react_1.default.createElement("div", { className: styles.integrationAlertLeft },
            react_1.default.createElement(icons_1.Warning, { className: styles.alertIcon, size: icons_1.IconSize.Small }),
            react_1.default.createElement(kaleidoscope_1.Text, { strong: true, size: "m", className: styles.integrationAlertLabel }, "App connection is required to create automation.")),
        react_1.default.createElement(kaleidoscope_1.Button, { type: kaleidoscope_1.ButtonType.Secondary, size: kaleidoscope_1.ButtonSize.Small, onClick: function () {
                OAuthWindow_1.default.show("".concat(apiBaseUrl).concat(integrationUrlMapping[selectedTarget.integrationName]), {
                    width: 900,
                    height: 1000,
                }).then(function () {
                    integrationChangeHandler(__assign(__assign({}, selectedTarget), { enabled: true }));
                });
            } }, "Connect app")));
};
exports.EnableIntegrationAlert = EnableIntegrationAlert;
